import React, { useEffect } from 'react';
import { useSnapshot } from 'valtio';
import SettingsSaveNotice from '../../components/SettingsSaveNotice';
import { supportsLightChannels } from '../../Utils/light_profiles';
import {
  discardLightDraft, keepLightDraft, lightDraftSubmission, lightSubmissionMessage,
  expireLightSubmission, LIGHT_SUBMISSION_TIMEOUT_MS
} from '../../Utils/light_channels_transaction';

export default function LightingSaveStatus({ controller }) {
  const live = useSnapshot(controller);
  const submission = lightDraftSubmission(live);
  useEffect(() => {
    if (submission?.status !== 'pending') return;
    const timer = setTimeout(() => expireLightSubmission(controller),
      Math.max(0, LIGHT_SUBMISSION_TIMEOUT_MS - (Date.now() - submission.started_at)));
    return () => clearTimeout(timer);
  }, [controller, submission?.status, submission?.started_at]);
  if (!live.access_rights?.lights?.read || !supportsLightChannels(live)) return null;
  const writable = Boolean(live.access_rights?.lights?.write);
  return <SettingsSaveNotice status={submission?.status}
    message={submission ? lightSubmissionMessage(submission) : ''} helpId="lighting_save_help"
    onUseController={writable ? () => {
      if (controller.access_rights?.lights?.write) discardLightDraft(controller);
    } : undefined}
    onKeep={() => { if (controller.access_rights?.lights?.write) keepLightDraft(controller); }}
    keepDisabled={live.settings.light_channels?.revision !== live.settings.light_channels_info?.revision} />;
}
